/* eslint-disable react-hooks/exhaustive-deps */
import React,{useMemo} from 'react';
import { Form, Row, Col, Button, Card } from 'react-bootstrap';
import JoditEditor from "jodit-react";
import { Formik, FieldArray } from 'formik';
import { Fetch, catchError } from '../../../utils/fetch'
import { useDispatch, useSelector } from 'react-redux';
import MediaUploader from '../../../utils/media-uploader'
import { AlertSuccess, AlertInfo, AlertConfirm } from '../../../components/alert';
import { loadingAction } from '../../../redux/actions'
import { useHistory, useParams } from 'react-router-dom';
import ModalComponent from '../../../components/modal';
import { validate } from '../validationSchema';
import { EstadoContenido } from '../../../utils/constants';
import PromocionesPlanes from '../promociones-planes/promocionesPlanes';
import { eliminarImagen, removeSpecial } from '../../../utils/tools';
import LayoutJodit from '../../../components/customizer/layout-jodit';
const VerPlan = () => {

    const { id, eliminar } = useParams()
    const dispatch = useDispatch()
    const history = useHistory()
    const isLoading = useSelector(state => state.loading)
    const permissions = useSelector(state => state.permissions)
    const [showModalColores, setShowModalColores] = React.useState(false)
    const [layoutJodit, setLayoutJodit] = React.useState("PC");
    //const canPublish = permissions.planes.publicar.enabled;
    const [formValues, setFormValues] = React.useState({})
    const [promosPlan,setPromosPlan]=React.useState([])

    // function preparePaste(jodit) {
    //     jodit.e.on(
    //         'paste',
    //         e => {

    //             jodit.e.stopPropagation('paste');
    //             let plainText = Jodit.modules.Helpers.getDataTransfer(e).getData(Jodit.constants.TEXT_PLAIN);plainText=removeSpecial(plainText);
    //             // plainText = plainText.replace(/(^|;)\s*font-[^;]+/g, "");
    //             // let regex = /<(?!(\/\s*)?(div|b|i|em|strong|u|p)[>,\s])([^>])*>/g;
    //             // plainText = plainText.replace(regex, '');
    //             plainText = plainText.normalize('NFKC').replaceAll("\n","<br/>");

    //             jodit.s.insertHTML(
    //                 plainText
    //             );
    //             return false;

    //         },
    //         { top: true }
    //     );
    // }
    // Jodit.plugins.add('preparePaste', preparePaste);

    const config = useMemo(
        () => ({
        readonly: false, // all options from https://xdsoft.net/jodit/doc/
        language: 'es',disablePlugins:['table'],
        askBeforePasteHTML: false,
        askBeforePasteFromWord: false,
        defaultActionOnPaste: "insert_clear_html",
        enableDragAndDropFileToEditor: true,
        uploader: {
            url: process.env.REACT_APP_BASE_URL + '/upload',
            headers: {
                'Authorization': 'Bearer ' + localStorage.getItem('jwt_token')
            },
            data: null,
            filesVariableName: function (i) {
                return "files"
            },
            withCredentials: false,
            pathVariableName: "path",
            format: "json",
            method: "POST",
            prepareData: function (formData) {
                formData.append('id', 1);

            },
            isSuccess: function (resp) {
                return !resp.error;
            },
            getMessage: function (resp) {
                return resp.msgs.join('\n');
            },
            process: function (resp) {
                return resp;
            },
            defaultHandlerSuccess: function (resp) {
                var imagenesPermitidas=["image/jpeg","image/png"];
                
                for (var i = 0; i < resp.length; i++) {
                    if(imagenesPermitidas.indexOf(resp[i].mime)!==-1)          
                        {
                            var img1 = new Image();
                            img1.src = resp[i]['url'];
                            img1.alt = 'imagen';
                            img1.className = "img-fluid"
                            this.s.insertImage(img1);
                        }else if(resp[i].mime==="application/pdf"){
                            const enlace = document.createElement('a');
                            enlace.setAttribute('href', resp[i].url);
                            const contenido = document.createTextNode(resp[i].name);
                            // add the text node to the newly created div
                            enlace.appendChild(contenido);
                            this.s.insertNode(enlace);
                        }else{
                            AlertInfo('Tipo de archivo no permitido');
                        }
                }
            }
        }
    }),[]);

    React.useEffect(() => {
        if (id) {
            getplanesById()
        }
    }, [id])

    const getplanesById = async (values) => {
        dispatch(loadingAction(true));

        try {
            const { data } = await Fetch(`planes/${id}`, "get");
            setFormValues(data)
            const promociones=data.promociones.map(item=>item.promocion).filter(item=>item!=null);            
            setPromosPlan(promociones)
            dispatch(loadingAction(false));
        } catch (error) {
            catchError(error)
            dispatch(loadingAction(false));
        }
    }


    const submit = async (values) => {
        dispatch(loadingAction(true));

        values.published_at = null;
        values.idPadre = values.id;
        values.estado = EstadoContenido.EnRevision
        values.promociones=promosPlan.map(item=> {
            return {promocion:item.id}
        });

        values.informacion=removeSpecial(values.informacion);

        try {

            const { data } = await Fetch("planes", "post", values);
            AlertInfo('Plan actualizado con éxito.<br/>Recuerde que falta su confirmación para aprobar.<br/> Nota: Por favor, notificar al responsable de publicar')

            dispatch(loadingAction(false));

            history.push("/planes/lista");


        } catch (error) {
            catchError(error)
            dispatch(loadingAction(false));
        }
    }


    const handleBlurTitulo = async (event, fn) => {
        const value = event.target.value;
        const name = event.target.name;
        const dataToApi = {
            contentTypeUID: "application::planes.planes",
            field: "slug",
            data: {
                nombre: value,
                slug: ""
            }
        }
        fn(name, value, false)
        try {
            const { data } = await Fetch("content-manager/uid/generate", "post", dataToApi);
            fn('slug', data.data, false)
        } catch (error) {
            console.error('mostrando error', error)
        }
    }

    const handleChangeJoiEditor = (data, field, fn) => {
        fn(field, data, false);
    }

    const initialValues = {
        nombre: "",
        descripcion: "",
        slug: "",
        miniatura: "",
        fondo: "",
        titulo: "",
        informacion: "",
        botones: [
            {
                nombre: "",
                url: "",
                archivo: "",
                estilo: "color1"
            }
        ],

        color: "color1",
        locale: "es",
    }

    const deleteContenido = async () => {
        dispatch(loadingAction(true));
        try {
            await Fetch('planes/' + id, 'delete')
            history.push('/')
            dispatch(loadingAction(false));
        } catch (error) {
            console.error('mostrando error', error)
            dispatch(loadingAction(false));
            catchError(error);
        }
    }

    function RenderAlert() {
        AlertConfirm('', 'Para eliminarlo definitivamente o recuperarlo deberás ir a la sección "Por eliminar".','question', (response) => {
            if (response.isConfirmed) {
                deleteContenido()
            }
        })
    }

    return (
        <React.Fragment>
            <Formik
                initialValues={formValues || initialValues}
                enableReinitialize
                validationSchema={validate}
                onSubmit={(values, { setSubmitting }) => {
                    // setTimeout(() => {
                    //   alert(JSON.stringify(values, null, 2));
                    //   setSubmitting(false);
                    // }, 400);
                    submit(values);
                }}
            >
                {({
                    values,
                    errors,
                    touched,
                    handleChange,
                    handleBlur,
                    handleSubmit,
                    setFieldValue,
                    isSubmitting,
                    setValues
                    /* and other goodies */
                }) => (
                    <form onSubmit={handleSubmit}>
                        <Row>
                            <Col>
                                <ModalComponent isShow={showModalColores} setShowModal={setShowModalColores} />
                            </Col>
                        </Row>
                        <Row>
                            <Col>
                                <Card>
                                    <Card.Header>
                                    Información del plan
                                    </Card.Header>
                                    <Card.Body>
                                        <Row>
                                            <Col>
                                                <Form.Group>
                                                    <label>Nombre del Plan</label>
                                                    <input type="text" name="nombre" onChange={handleChange} onBlur={(e) => handleBlurTitulo(e, setFieldValue)} value={values?.nombre} className="form-control " />
                                                    {errors &&
                                                        errors.nombre &&
                                                        (<div className="text-danger">{errors.nombre}</div>)}
                                                </Form.Group>
                                            </Col>
                                        </Row>
                                        <Row>
                                            <Col>
                                                <Form.Group>
                                                    <label>Url</label>
                                                    <input type="text" name="slug" className="form-control" value={values?.slug} readOnly />
                                                    {errors &&
                                                        errors.url &&
                                                        (<div className="text-danger">{errors.url}</div>)}
                                                </Form.Group>
                                            </Col>
                                        </Row>
                                        <Row>
                                            <Col>
                                                <Form.Group>
                                                    <label>Descripcion del Plan</label>
                                                    <input type="text" name="descripcion" onChange={handleChange} value={values.descripcion} className="form-control " />
                                                    {errors &&
                                                        errors.descripcion &&
                                                        (<div className="text-danger">{errors.descripcion}</div>)}
                                                </Form.Group>
                                            </Col>
                                        </Row>
                                        <Row>
                                            <Col>
                                                <Form.Group>
                                                    <label>Color de Plan</label>
                                                    <button type="button" onClick={() => setShowModalColores(true)} className="btn btn-info btn-xs me-2 btn-rounded">?</button>
                                                    <select name="color" onChange={handleChange} className="form-control" value={values?.color}>
                                                        <option>Seleccionar</option>
                                                        <option value="color1">Color 1</option>
                                                        <option value="color2">Color 2</option>
                                                        <option value="color3">Color 3</option>
                                                        <option value="color4">Color 4</option>
                                                        <option value="color5">Color 5</option>
                                                        <option value="color6">Color 6</option>
                                                        <option value="color7">Color 7</option>
                                                    </select>
                                                    {errors &&
                                                        errors.color &&
                                                        (<div className="text-danger">{errors.color}</div>)}
                                                </Form.Group>
                                            </Col>
                                        </Row>

                                        {values.miniatura && Object.keys(values.miniatura).length > 0 &&
                                           <>
                                           <Row>
                                               <Col>
                                                   <Form.Group>
                                                       <img src={values.miniatura.url} alt="vista-previa" className="img-fluid w-50" />
                                                   </Form.Group>
                                               </Col>
                                           </Row>
                                           <Row>
                                             <Col>
                                               <Button
                                                 type="button"
                                                 style={{ marginBottom: "10px" }}
                                                 onClick={() => {
                                                   eliminarImagen(values.miniatura.id).then(
                                                     (response) => {
                                                       setFieldValue("miniatura", "", false);
                                                     }
                                                   ).catch(error=>{});
                                                 }}
                                                 className="btn btn-danger btn-icon mt-2"
                                               >
                                                 <i className="fa fa-trash-o " />
                                                 Eliminar
                                               </Button>
                                             </Col>
                                           </Row>
                                           </>
                                        }

                                        <Row>
                                            <Col>
                                                <Form.Group>
                                                    <label>Imagen Miniatura</label>
                                                    <MediaUploader value={values?.miniatura?100:0} key={values?.miniatura} setFieldValue={(name,value)=>{setFieldValue(name,value,false);setValues({...values,[name]:value})}} field={'miniatura'} tipoMedia='imagen' ancho={300} alto={370} />
                                                    {errors &&
                                                        errors.miniatura &&
                                                        (<div className="text-danger">{errors.miniatura}</div>)}
                                                    <span className="text-muted">Se recomienda una imagen de 300px de ancho x 370px de alto</span>
                                                </Form.Group>
                                            </Col>
                                        </Row>

                                        {values.fondo && Object.keys(values.fondo).length > 0 &&
                                             <>
                                             <Row>
                                               <Col>
                                                 <Form.Group>
                                                   <img
                                                     src={values.fondo.url}
                                                     alt="vista-previa"
                                                     className="img-fluid w-50"
                                                   />
                                                 </Form.Group>
                                               </Col>
                                             </Row>
                                             <Row>
                                               <Col>
                                                 <Button
                                                   type="button"
                                                   style={{ marginBottom: "10px" }}
                                                   onClick={() => {
                                                     eliminarImagen(values.fondo.id).then(
                                                       (response) => {
                                                         setFieldValue("fondo", "", false);
                                                       }
                                                     ).catch(error=>{});
                                                   }}
                                                   className="btn btn-danger btn-icon mt-2"
                                                 >
                                                   <i className="fa fa-trash-o " />
                                                   Eliminar
                                                 </Button>
                                               </Col>
                                             </Row>
                                           </>
                                        }

                                        <Row>
                                            <Col>
                                                <Form.Group>
                                                    <label>Imagen de Fondo</label>
                                                    <MediaUploader value={values?.fondo?100:0} key={values?.fondo} setFieldValue={(name,value)=>{setFieldValue(name,value,false);setValues({...values,[name]:value})}} field={'fondo'} tipoMedia='imagen' ancho={300} alto={370} />
                                                    {errors &&
                                                        errors.fondo &&
                                                        (<div className="text-danger">{errors.fondo}</div>)}
                                                    <span className="text-muted">Se recomienda una imagen de 300px de ancho x 370px de alto</span>
                                                </Form.Group>
                                            </Col>
                                        </Row>
                                        <Row>
                                            <Col>
                                                <Form.Group>
                                                    <label>Titulo</label>
                                                    <input type="text" name="titulo" onChange={handleChange} className="form-control" value={values.titulo} />
                                                    {errors &&
                                                        errors.titulo &&
                                                        (<div className="text-danger">{errors.titulo}</div>)}
                                                </Form.Group>
                                            </Col>
                                        </Row>
                                        <Row>
                                            <Col className={`${layoutJodit == "MOBILE" && "col-6"}`}>
                                                <Form.Group>
                                                    <label>Informacion</label>
                                                    <LayoutJodit
                                                        setLayoutJodit={setLayoutJodit}
                                                        layoutJodit={layoutJodit}
                                                    />     
                                                    <JoditEditor
                                                        config={config}
                                                        value={values.informacion}
                                                        tabIndex={1} // tabIndex of textarea
                                                        onBlur={newContent => handleChangeJoiEditor(newContent, 'informacion', setFieldValue)}
                                                    />
                                                    {errors &&
                                                        errors.informacion &&
                                                        (<div className="text-danger">{errors.informacion}</div>)}
                                                </Form.Group>
                                            </Col>
                                        </Row>

                                        {/* Botones */}
                                        <Row>
                                            <Col>
                                                <h2>Botones</h2>
                                            </Col>
                                        </Row>
                                        <FieldArray name="botones">
                                            {({ move, swap, push, remove, insert, unshift, pop, form }) => {
                                                return (
                                                    <>
                                                        {values?.botones && values?.botones?.length > 0 &&
                                                            values?.botones.map((data, index) => {
                                                                const hasArchivo = !!data?.archivo?.url;
                                                                return (
                                                                    <Row key={index}>


                                                                        <Col>
                                                                            <Row className="border m-3">

                                                                                <Col lg={12} className="p-0 d-flex justify-content-end">
                                                                                    <button type="button" className="btn btn-danger" onClick={() => remove(index)}>x</button>
                                                                                </Col>
                                                                                <Col lg={12}>
                                                                                    <div className="form-group">
                                                                                        <label>Nombre</label>
                                                                                        <input type="text" className="form-control" name={`botones.${index}.nombre`} onChange={handleChange} value={values.botones[index].nombre} />
                                                                                        {errors &&
                                                                                            errors.botones &&
                                                                                            errors.botones[index] &&
                                                                                            errors.botones[index].nombre &&
                                                                                            (<div className="text-danger">{errors.botones[index].nombre}</div>)}
                                                                                    </div>
                                                                                </Col>
                                                                                <Col lg={12}>
                                                                                    <div className="form-group">
                                                                                        <label>Url</label>
                                                                                        <input type="text" className="form-control" name={`botones.${index}.url`} onChange={handleChange} value={values.botones[index].url} />
                                                                                        {errors &&
                                                                                            errors.botones &&
                                                                                            errors.botones[index] &&
                                                                                            errors.botones[index].url &&
                                                                                            (<div className="text-danger">{errors.botones[index].url}</div>)}
                                                                                    </div>
                                                                                </Col>
                                                                                <Col lg={12}>
                                                                                    <div className="form-group">
                                                                                        <label>Archivo (imagen o PDF)</label>

                                                                                        {hasArchivo && (
                                                                                        <>
                                                                                            <div className="mb-2">
                                                                                            {data.archivo.mime?.startsWith("image/") ? (
                                                                                                <img
                                                                                                src={data.archivo.url}
                                                                                                alt="vista-previa"
                                                                                                className="img-fluid w-50"
                                                                                                />
                                                                                            ) : (
                                                                                                <a
                                                                                                href={data.archivo.url}
                                                                                                target="_blank"
                                                                                                rel="noreferrer"
                                                                                                >
                                                                                                {data.archivo.name || "Ver archivo"}
                                                                                                </a>
                                                                                            )}
                                                                                            </div>

                                                                                            <Button
                                                                                            type="button"
                                                                                            style={{ marginBottom: "10px" }}
                                                                                            onClick={() => {
                                                                                                eliminarImagen(data.archivo.id)
                                                                                                .then(() => {
                                                                                                    setFieldValue(`botones.${index}.archivo`, "", false);
                                                                                                    setValues({
                                                                                                    ...values,
                                                                                                    botones: values.botones.map((item, i) =>
                                                                                                        i === index ? { ...item, archivo: "" } : item
                                                                                                    ),
                                                                                                    });
                                                                                                })
                                                                                                .catch(() => {});
                                                                                            }}
                                                                                            className="btn btn-danger btn-icon mt-2"
                                                                                            >
                                                                                            <i className="fa fa-trash-o " />
                                                                                            Eliminar archivo
                                                                                            </Button>
                                                                                        </>
                                                                                        )}

                                                                                        {!hasArchivo && (
                                                                                        <MediaUploader
                                                                                            value={0}
                                                                                            key={data?.archivo?.id || `boton-archivo-${index}`}
                                                                                            setFieldValue={(name, value) => {
                                                                                            setFieldValue(name, value, false);
                                                                                            setValues({
                                                                                                ...values,
                                                                                                botones: values.botones.map((item, i) =>
                                                                                                i === index ? { ...item, archivo: value } : item
                                                                                                ),
                                                                                            });
                                                                                            }}
                                                                                            field={`botones.${index}.archivo`}
                                                                                            tipoMedia="file"
                                                                                            ancho={400}
                                                                                            alto={400}
                                                                                        />
                                                                                        )}
                                                                                    </div>
                                                                                </Col>
                                                                                <Col lg={12}>
                                                                                    <div className="form-group">
                                                                                        <label>Estilo</label>
                                                                                        <button type="button" onClick={() => setShowModalColores(true)} className="btn btn-info btn-xs me-2 btn-rounded">?</button>
                                                                                        <select className="form-control" name={`botones.${index}.estilo`} onChange={handleChange} value={values.botones[index].estilo}>
                                                                                            <option>Seleccionar</option>
                                                                                            <option value="color1">Color 1</option>
                                                                                            <option value="color2">Color 2</option>
                                                                                            <option value="color3">Color 3</option>
                                                                                            <option value="color4">Color 4</option>
                                                                                            <option value="color5">Color 5</option>
                                                                                            <option value="color6">Color 6</option>
                                                                                            <option value="color7">Color 7</option>
                                                                                        </select>
                                                                                        {errors &&
                                                                                            errors.botones &&
                                                                                            errors.botones[index] &&
                                                                                            errors.botones[index].estilo &&
                                                                                            (<div className="text-danger">{errors.botones[index].estilo}</div>)}
                                                                                    </div>
                                                                                </Col>
                                                                            </Row>

                                                                            <Row>
                                                                            </Row>
                                                                        </Col>
                                                                    </Row>
                                                                )
                                                            }

                                                            )}
                                                        <button type="button" className="btn btn-secondary" onClick={() => push({ nombre: "", url: "", archivo: "", estilo: '' })}>Añadir Item</button>
                                                    </>
                                                )
                                            }
                                            }
                                        </FieldArray>
                                        <Row>
                                            <PromocionesPlanes key={promosPlan.length}  promosPlan={promosPlan} setPromosPlan={setPromosPlan}/>
                                        </Row>
                                        <Row>
                                            <Col>
                                                {/* <Button type="button" onClick={() => handleSubmit()} disabled={isLoading} className="btn btn-success btn-icon mt-2" ><i className="fa fa-floppy-o " />Guardar</Button> */}
                                                {eliminar
                                                    ?
                                                    (
                                                        <Button
                                                            type="button"
                                                            onClick={() => RenderAlert()}
                                                            disabled={isLoading}
                                                            className="btn btn-danger btn-icon mt-2"
                                                        >
                                                            <i className="fa fa-trash-o " />
                                                            Eliminar
                                                        </Button>
                                                    )
                                                    :
                                                    (
                                                        <Button
                                                            type="button"
                                                            onClick={() => handleSubmit()}
                                                            disabled={isLoading}
                                                            className="btn btn-success btn-icon mt-2"
                                                        >
                                                            <i className="fa fa-floppy-o " />
                                                            Guardar
                                                        </Button>
                                                    )
                                                }
                                            </Col>
                                        </Row>
                                    </Card.Body>
                                </Card>
                            </Col>
                        </Row>


                    </form>

                )}
            </Formik>

        </React.Fragment>
    );
}
export default VerPlan;